module.exports = __webpack_public_path__ + "img/eye.284d4165.svg";